/* eslint-disable max-classes-per-file */
import { ProfitModel } from '../../profit/models/profit.model';
import { BenefitModel } from '../benefit/models/benefit.model';
import { ChargeModel } from '../charge/models/charges.model';
import { DriversFactorModel } from '../driversFactor/models/driversFactor.model';
import { FleetModel } from '../fleet/models/fleet.model';
import { GeneralCostsModel } from '../general-costs/models/general-costs.model';
import { GetGeneralCostsModel } from '../general-costs/models/get-general-cost.model';
import { InvoicingModel } from '../invoicing/invoicing.model';
import { OperationalTeamModel } from '../operational-team/models/operational-team.model';
import { PlantModel } from '../plant/plant.model';
import { RvParameterModel } from '../rv-parameter/model/rv-parameter.model';
import { ScopeDfdvModel } from '../scope/model/scope-dfdv.model';
import { SummaryModel } from '../summary/models/summary.model';
import { TaxModel } from '../taxes/models/tax.model';
import {
  CVConsumptionModel,
  CVMaintenanceModel,
  CVTireModel,
} from '../variable-costs/models/variable-costs.model';
import { SupportTeamModel } from './support-team/support-team.model';
import { TableModel } from './table/table.model';

export class GetDfdvModel {
  [key: string]: any;

  dfdvId!: number;
  unitName!: string;
  categoryName!: string;
  fantasyName!: string;
  operatorId!: string;
  copyId!: string;
  creationDate!: Date | null;
  startDate!: Date | null;
  endDate!: Date | null;
  version!: number;
  previousVersionId!: number;
  nextVersionId!: number;
  dfdvTypeName!: string;
  dfdvStatusName!: string;

  attachments!: DfdvAttachmentModel[];
  rvParameter!: RvParameterModel;
  driverFactor!: DriversFactorModel;
  plant!: PlantModel;
  generalCosts!: GetGeneralCostsModel | undefined;
  profit!: ProfitModel;
  benefit!: BenefitModel;
  charge!: ChargeModel;
  tax!: TaxModel;
  scope!: ScopeDfdvModel;
  operationalTeam!: OperationalTeamModel;
  cvMaintenance!: CVMaintenanceModel;
  cvConsumption!: CVConsumptionModel[];
  cvTire!: CVTireModel;
  table!: TableModel[];
  invoicing?: InvoicingModel;
  summary!: SummaryModel;
  fleet!: FleetModel;
  supportTeam!: SupportTeamModel;
}

export class DfdvAttachmentModel {
  fileName!: string;
  fileSize!: number;
}
